module.exports = __webpack_public_path__ + "img/IS.f4178f5e.svg";